import React from "react"

const Container = React.forwardRef(
  ({ children, wide = false, className = "", style, ...props }, ref) => {
    const maxWidth = wide ? null : "min(100%, 1440px)"
    return (
      <div
        className={`mx-auto px-8 ${className}`.trim()}
        style={{ ...style, maxWidth }}
        ref={ref}
        {...props}
      >
        {children}
      </div>
    )
  }
)

export default Container
